import styled from "styled-components"
import { transparentize } from "polished"

const StyledMapWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

const StyledOverviewInfo = styled.span`
  cursor: pointer;
  font-family: ${({ theme }) => theme.font.family.body};
  font-size: ${({ theme }) => theme.font.size.md};
  line-height: 1.75;
  color: ${({ theme }) => theme.color.main03};
  display: flex;
  align-items: center;

  > svg {
    margin-right: 0.8rem;
    min-width: 2.4rem;
  }

  &:hover {
    color: ${({ theme }) => theme.color.main02};
  }
`

const StyledInformation = styled.span`
  display: flex;
  position: absolute;
  z-index: 10;
  box-shadow: 0px 0.2rem 0.4rem 0px
    ${({ theme }) => transparentize(0.88, theme.color.main01)};
  background-color: ${({ theme }) => theme.color.white};
  line-height: 1.75;
  color: ${({ theme }) => theme.color.main03};
  justify-content: center;
  align-items: center;
  padding: 0.6rem 1.6rem;
  bottom: 15.8rem;
  left: 50%;
  transform: translateX(-50%);
  min-width: calc(100% - 2.4rem);
  > svg {
    min-width: 2.4rem;
    margin-right: 0.8rem;
  }

  ${({ theme }) => theme.mq.medium} {
    bottom: 1.6rem;
    min-width: 50.2rem;
    height: 3.7rem;
    left: calc(50% + 37.6rem);
    transform: translateX(calc(-50% - 18.8rem));
  }
`
export { StyledMapWrapper, StyledInformation, StyledOverviewInfo }
